import React from "react";

import { QuestionnaireRow } from "components/AttachmentForm/Components";
import { NVDOptionToggler } from "components/AttachmentForm/NVDOptionToggles";
import { Column } from "components/Layout";

export const HG0324 = () => (
  <Column>
    <QuestionnaireRow>
      <NVDOptionToggler
        name="declaration.meets_harvested_rangeland_goat_definition"
        label="1."
      />
    </QuestionnaireRow>
  </Column>
);
